import { render } from "./InspectionDuplicate.vue?vue&type=template&id=299f18aa"
import script from "./InspectionDuplicate.vue?vue&type=script&lang=js"
export * from "./InspectionDuplicate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__